function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _templateObject12() {
  var data = _taggedTemplateLiteral(["\n    flex-direction: row;\n "]);

  _templateObject12 = function _templateObject12() {
    return data;
  };

  return data;
}

function _templateObject11() {
  var data = _taggedTemplateLiteral(["\n   margin-left: 0;\n   \n   ", " {\n      width: 120px;\n    }\n     ", ",\n     ", " {\n      background-color: ", ";\n    }\n "]);

  _templateObject11 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10() {
  var data = _taggedTemplateLiteral(["\n   margin-left: auto;\n "]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = _taggedTemplateLiteral(["\n    justify-content: flex-start;\n    align-items: center;\n "]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n    margin-top: auto;\n    padding-top: 10px;\n "]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n    flex-wrap: wrap;\n    \n    > * {\n      width: 100%;\n    }\n "]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n   margin-left: auto;\n   text-align: right;\n "]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n    border-bottom: 1px solid #f0f1f2;\n    border-radius: 0;\n  "]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  ", "\n  "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n     & ", " {\n      opacity: 1;\n     }\n  "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n      opacity: 1;\n    "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    padding-right: 0;\n    margin-left: 16px;\n    margin-right: 16px;\n  "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

import React, { useContext, useEffect, useRef, useState } from 'react';
import styled, { css, ThemeContext, ThemeProvider } from 'styled-components';
import { EnumButtonSize, EnumCardSize, EnumCardType, EnumFavoriteStates, EnumProductStates, EnumProductType } from "./types";
import Image from "./components/Image";
import Quantity, { CartQuantity } from "./components/ListQuantity";
import Controls from "./components/ListControls";
import FavoriteButton from "./components/FavoriteButton";
import { defaultProductCardTheme, defaultProductListTheme, FavoriteSizes, ImageSizes, PriceSizes } from "./theme";
import { CommentButtonDesktop } from "./components/CommentButton";
import CommentField, { CardNote } from "./components/CommentField";
import Box from "../Grid/Box";
import Flex from "../Grid/Flex";
import { hideAfterSm, hideBeforeSm, mediaSmDown, mediaSmUp } from "../../theme/helpers/media";
import { ListPrice, OldListPrice, KomusOldListPrice } from "./components/ProductPrice";
import DraggableCard from "./DraggableCard";
import { ProductName } from "./components/Name";
import { ControlsWrapper, QuantityButton } from "../QuantityControls";
import colors from "../../colors";
import MobileActionButtons from "./components/MobileActionButtons";
import { calcProductPrices } from "./helpers";
import RemoveButton from "./components/RemoveButton";
import { hoverStyles, RelativeBox } from "./styled";
import { ErrorMessage } from "./components/Textarea";
import { addStyleIfPropTruly } from "../../utils/styledComponents";
import { numberToFormattedCurrencyString } from "../QuantityControls/helpers";
var RemoveButtonStyled = styled(RemoveButton).withConfig({
  displayName: "ListCard__RemoveButtonStyled",
  componentId: "sc-15x5qnx-0"
})(["position:absolute;right:-32px;top:8px;opacity:0;", ""], hideBeforeSm);
var Content = styled(Flex).attrs({
  grow: true,
  column: true
}).withConfig({
  displayName: "ListCard__Content",
  componentId: "sc-15x5qnx-1"
})([""]);
var Container = styled(Flex).attrs({
  px: 3,
  py: 3
}).withConfig({
  displayName: "ListCard__Container",
  componentId: "sc-15x5qnx-2"
})(["border-radius:", "px;position:relative;transition:box-shadow ", " ease-in;", " ", "{opacity:", ";transition:opacity ", " ease-in;", "}&:hover,&:focus{", " & ", "{opacity:1;}", "}", " ", " ", " ", ""], function (_ref) {
  var theme = _ref.theme;
  return theme.borderRadius;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.speedTransition;
}, mediaSmDown(_templateObject()), Controls, function (_ref3) {
  var alwaysShowAddToCard = _ref3.theme.alwaysShowAddToCard;
  return alwaysShowAddToCard ? 1 : 0;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.speedTransition;
}, mediaSmDown(_templateObject2()), hoverStyles, RemoveButtonStyled, mediaSmUp(_templateObject3(), Controls), function (_ref5) {
  var focused = _ref5.focused;
  return focused && hoverStyles;
}, function (_ref6) {
  var active = _ref6.active;
  return active && css(["& ", "{opacity:1;}"], Controls);
}, mediaSmUp(_templateObject4(), addStyleIfPropTruly('withBorder', "\n      border-radius: 12px;\n      border: 1px solid ".concat(colors.paleGrey, ";\n  \n      &:hover {\n        box-shadow: none;\n      }\n      "))), mediaSmDown(_templateObject5()));
var FavoriteStyled = styled(FavoriteButton).withConfig({
  displayName: "ListCard__FavoriteStyled",
  componentId: "sc-15x5qnx-3"
})(["position:absolute;top:0;left:0;"]);
var CommentFieldStyled = styled(CommentField).withConfig({
  displayName: "ListCard__CommentFieldStyled",
  componentId: "sc-15x5qnx-4"
})(["position:relative;z-index:0;flex-grow:1;", "{position:relative;bottom:0;padding-top:0;padding-left:0;padding-bottom:0;transform:none;&:before,&:after{display:none;}}", "{position:relative;}", ""], CardNote, ErrorMessage, hideBeforeSm);
var QuantityStyled = styled(Quantity).withConfig({
  displayName: "ListCard__QuantityStyled",
  componentId: "sc-15x5qnx-5"
})(["width:60px;flex-grow:0;", " ", ";"], mediaSmDown(_templateObject6()), function (_ref7) {
  var isKomus = _ref7.isKomus;

  if (isKomus) {
    return css(["line-height:16px !important;font-size:14px !important;font-weight:normal;color:", " !important;"], colors.dark200);
  }
});
var InfoBox = styled(Flex).attrs({
  pl: 4,
  between: true
}).withConfig({
  displayName: "ListCard__InfoBox",
  componentId: "sc-15x5qnx-6"
})(["align-items:baseline;position:relative;flex-grow:1;", ""], mediaSmDown(_templateObject7()));
var ControlBox = styled(Flex).attrs({
  between: true,
  pl: 4
}).withConfig({
  displayName: "ListCard__ControlBox",
  componentId: "sc-15x5qnx-7"
})(["position:relative;", " ", ""], mediaSmUp(_templateObject8()), mediaSmDown(_templateObject9()));
var FullPrice = styled(Flex).attrs({
  end: true
}).withConfig({
  displayName: "ListCard__FullPrice",
  componentId: "sc-15x5qnx-8"
})(["align-items:baseline;white-space:nowrap;flex-shrink:0;", " ", "{", "}", "{", "}", ""], addStyleIfPropTruly('isFullCardType', "flex-basis: 150px;"), OldListPrice, hideBeforeSm, KomusOldListPrice, hideBeforeSm, mediaSmDown(_templateObject10()));
var ProductNameStyled = styled(ProductName).withConfig({
  displayName: "ListCard__ProductNameStyled",
  componentId: "sc-15x5qnx-9"
})(["margin-bottom:4px;flex-grow:1;width:100%;max-height:38px;"]);
var MobileCommentIndicator = styled.div.withConfig({
  displayName: "ListCard__MobileCommentIndicator",
  componentId: "sc-15x5qnx-10"
})(["position:absolute;right:0;width:4px;height:100%;background-color:", ";", ""], colors.darkBlueGreen, hideAfterSm);
var ImageStyled = styled(Image).withConfig({
  displayName: "ListCard__ImageStyled",
  componentId: "sc-15x5qnx-11"
})(["", ""], function (_ref8) {
  var borderRadius = _ref8.theme.borderRadius,
      withFullImage = _ref8.withFullImage;
  return withFullImage && addStyleIfPropTruly('withFullImage', "\n        background-size: cover;\n        border-radius: ".concat(borderRadius, "px;\n        "));
});
var ControlsStyled = styled(Controls).withConfig({
  displayName: "ListCard__ControlsStyled",
  componentId: "sc-15x5qnx-12"
})(["margin-left:auto;flex-shrink:0;", ""], mediaSmDown(_templateObject11(), ControlsWrapper, ControlsWrapper, QuantityButton, colors.white));
var DesktopWrapper = styled.div.withConfig({
  displayName: "ListCard__DesktopWrapper",
  componentId: "sc-15x5qnx-13"
})(["", ""], hideBeforeSm);
var MobileWrapper = styled(Flex).withConfig({
  displayName: "ListCard__MobileWrapper",
  componentId: "sc-15x5qnx-14"
})(["", ""], hideAfterSm);
var NameBox = styled(Flex).attrs({
  column: true
}).withConfig({
  displayName: "ListCard__NameBox",
  componentId: "sc-15x5qnx-15"
})(["", ""], mediaSmDown(_templateObject12()));
var CommentButtonStyled = styled(CommentButtonDesktop).withConfig({
  displayName: "ListCard__CommentButtonStyled",
  componentId: "sc-15x5qnx-16"
})(["position:absolute;top:10px;left:16px;"]);

var ConditionalWrapper = function ConditionalWrapper(_ref9) {
  var condition = _ref9.condition,
      wrapper = _ref9.wrapper,
      children = _ref9.children;
  return React.createElement(React.Fragment, null, condition && wrapper ? wrapper(children) : children);
};

var ListCard = function ListCard(_ref10) {
  var _product$image;

  var product = _ref10.product,
      className = _ref10.className,
      state = _ref10.state,
      onAddToCart = _ref10.onAddToCart,
      onAddToOrder = _ref10.onAddToOrder,
      showAddToOrder = _ref10.showAddToOrder,
      onQuantityChange = _ref10.onQuantityChange,
      _ref10$favoriteState = _ref10.favoriteState,
      favoriteState = _ref10$favoriteState === void 0 ? EnumFavoriteStates["default"] : _ref10$favoriteState,
      favoriteTextForTempUser = _ref10.favoriteTextForTempUser,
      onRemoveFromCart = _ref10.onRemoveFromCart,
      onFavoriteClick = _ref10.onFavoriteClick,
      onCommentMobileBtnSubmit = _ref10.onCommentMobileBtnSubmit,
      onCommentFieldSubmit = _ref10.onCommentFieldSubmit,
      onCommentFieldChange = _ref10.onCommentFieldChange,
      commentMaxLength = _ref10.commentMaxLength,
      commentPlaceholder = _ref10.commentPlaceholder,
      renderLinkWrapper = _ref10.renderLinkWrapper,
      onReplace = _ref10.onReplace,
      _ref10$inOrder = _ref10.inOrder,
      inOrder = _ref10$inOrder === void 0 ? false : _ref10$inOrder,
      _ref10$sizeCard = _ref10.sizeCard,
      sizeCard = _ref10$sizeCard === void 0 ? EnumCardSize.medium : _ref10$sizeCard,
      _ref10$typeCard = _ref10.typeCard,
      typeCard = _ref10$typeCard === void 0 ? EnumCardType.full : _ref10$typeCard,
      fullImage = _ref10.fullImage,
      renderTopSlot = _ref10.renderTopSlot,
      isKomus = _ref10.isKomus;
  var themeContext = useContext(ThemeContext);

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isMobileControlsVisible = _useState2[0],
      setMobileControlsVisibility = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      focused = _useState4[0],
      setFocused = _useState4[1];

  var resultTheme = _objectSpread({}, defaultProductCardTheme, {}, defaultProductListTheme, {}, themeContext);

  var commentRef = useRef(null);
  var isProductInCart = state === EnumProductStates.inBasket;
  var isPriceApproximate = product.amount > 0 && product.type === EnumProductType.pack;
  var isNotAvailable = state === EnumProductStates.notAvailable || !product.available;
  var isProductWithActions = !!onRemoveFromCart || !!onCommentMobileBtnSubmit;
  var isMediumSize = sizeCard === EnumCardSize.medium;

  var _useState5 = useState(false),
      _useState6 = _slicedToArray(_useState5, 2),
      isMobile = _useState6[0],
      setIsMobile = _useState6[1];

  var _calcProductPrices = calcProductPrices(product),
      currentPrice = _calcProductPrices.currentPrice,
      oldPrice = _calcProductPrices.oldPrice;

  var isFullCardType = typeCard === EnumCardType.full;
  useEffect(function () {
    setIsMobile(window.matchMedia("(max-width: ".concat(resultTheme.breakpoints.sm, "px)")).matches);
  }, [resultTheme.breakpoints.sm]);
  var cartQuantity = !isProductInCart && product.amount > 0 && React.createElement(CartQuantity, {
    weight: product.item_weight,
    amount: product.amount,
    type: product.type,
    measure: product.unit_in_price_per_kg
  });

  var resultPrice = function resultPrice(oldPrice) {
    return isKomus ? React.createElement(KomusOldListPrice, null, React.createElement("s", null, numberToFormattedCurrencyString(oldPrice), " ", resultTheme.priceSign)) : React.createElement(OldListPrice, null, React.createElement("s", null, numberToFormattedCurrencyString(oldPrice), " ", resultTheme.priceSign));
  };

  return React.createElement(ThemeProvider, {
    theme: resultTheme
  }, React.createElement(ConditionalWrapper, {
    condition: isProductWithActions && isMobile,
    wrapper: function wrapper(children) {
      return React.createElement(DraggableCard, {
        rightButtons: React.createElement(MobileActionButtons, {
          onRemoveFromCart: onRemoveFromCart,
          onCommentMobileBtnSubmit: onCommentMobileBtnSubmit,
          isKomus: isKomus
        })
      }, children);
    }
  }, !!onCommentMobileBtnSubmit && !!product.comment && React.createElement(MobileCommentIndicator, null), React.createElement(Container, {
    tabIndex: 0,
    className: className,
    active: isProductInCart,
    focused: focused,
    disabled: isNotAvailable,
    onBlur: function onBlur() {
      setFocused(false);
    },
    withBorder: !isFullCardType
  }, React.createElement(RelativeBox, null, React.createElement(ConditionalWrapper, {
    condition: !!renderLinkWrapper,
    wrapper: renderLinkWrapper
  }, React.createElement(ImageStyled, {
    size: isMediumSize ? ImageSizes.medium : ImageSizes.small,
    src: (_product$image = product.image) === null || _product$image === void 0 ? void 0 : _product$image.medium,
    disabled: isNotAvailable,
    withFullImage: fullImage
  })), product.favorite && React.createElement(FavoriteStyled, {
    isKomus: isKomus,
    isActive: product.favorite,
    state: favoriteState,
    textInfoPopup: favoriteTextForTempUser,
    onFavoriteClick: onFavoriteClick,
    size: isMediumSize ? FavoriteSizes.medium : FavoriteSizes.small
  })), React.createElement(Content, null, React.createElement(InfoBox, null, React.createElement(ConditionalWrapper, {
    condition: !!renderLinkWrapper,
    wrapper: renderLinkWrapper
  }, React.createElement(NameBox, null, React.createElement(ProductNameStyled, {
    notAvailable: isNotAvailable,
    isKomus: isKomus
  }, product.name), React.createElement(QuantityStyled, {
    display_weight: product.display_weight,
    type: product.type,
    isKomus: isKomus
  }))), React.createElement(Box, {
    ml: true,
    mr: 3,
    hideBefore: "md"
  }, renderTopSlot && renderTopSlot()), React.createElement(FullPrice, {
    isFullCardType: isFullCardType,
    middle: true
  }, React.createElement(Box, {
    ml: 3,
    mr: true,
    hideAfter: "md",
    hideBefore: "sm"
  }, renderTopSlot && renderTopSlot()), React.createElement(Box, {
    mr: 3
  }, oldPrice && product.available && resultPrice(oldPrice)), React.createElement(DesktopWrapper, null, React.createElement(ListPrice, {
    price: currentPrice,
    disabled: !product.available,
    sale: product.sale,
    approximate: isPriceApproximate,
    priceSize: isMediumSize ? PriceSizes.big : PriceSizes.medium,
    isKomus: isKomus
  }), cartQuantity))), React.createElement(ControlBox, null, isProductInCart && onCommentFieldSubmit && React.createElement(React.Fragment, null, !!product.comment && React.createElement(CommentButtonStyled, {
    isKomus: isKomus
  }), React.createElement(CommentFieldStyled, {
    ref: commentRef,
    value: product.comment,
    placeholder: commentPlaceholder,
    onSubmit: onCommentFieldSubmit,
    onChange: onCommentFieldChange,
    maxLength: commentMaxLength,
    isKomus: isKomus
  })), isFullCardType && React.createElement(ControlsStyled, {
    quantity: product.amount,
    weight: product.item_weight,
    state: state,
    onAddToCart: onAddToCart,
    onAddToOrder: onAddToOrder,
    onQuantityChange: onQuantityChange,
    showWeight: product.type === EnumProductType.weight,
    canAddToOrder: Boolean(showAddToOrder),
    isMobileControlsVisible: isMobileControlsVisible,
    onReplace: onReplace,
    toggleMobileControls: function toggleMobileControls(val) {
      setMobileControlsVisibility(val);
    },
    size: isMediumSize && !isMobile ? EnumButtonSize.normal : EnumButtonSize.small,
    isKomus: isKomus
  }), React.createElement(MobileWrapper, {
    between: true,
    grow: true,
    middle: true
  }, cartQuantity, React.createElement(FullPrice, null, React.createElement(ListPrice, {
    price: currentPrice,
    disabled: !product.available,
    sale: product.sale,
    approximate: isPriceApproximate,
    priceSize: isMediumSize ? PriceSizes.big : PriceSizes.medium
  }))))), inOrder && !!onRemoveFromCart && React.createElement(RemoveButtonStyled, {
    onClick: onRemoveFromCart,
    isKomus: isKomus
  }))));
};

export default ListCard;